// Typelizer digest 537e71edfcf998100ae7c4a1db9e9051
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** DELETE /api/attachments/:id */
  destroy: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/api/attachments/:id', params, options),
    method: 'delete',
  }),
}
